import React from 'react';

import { useFormDataQuery } from '@/api/getters';
import { Stages } from '@/api/types';
import ClientCardHHSurveys from '@/features/v2/hh/components/layout/ClientCardHHSurveys';
import ClientCardOffer from '@/features/v2/hh/components/layout/ClientCardOffer';

const ClientCardHH = ({
  className,
  isOfferPage,
  isMobileMenu,
}: {
  className?: string;
  isOfferPage?: boolean;
  isMobileMenu?: boolean;
}) => {
  const { data: formData } = useFormDataQuery();
  if (isOfferPage)
    return (
      <ClientCardOffer
        isMobileMenu={isMobileMenu}
        withPdf={
          formData?.stage === Stages.OFFER && !formData?.offer?.offer_rejected
        }
      />
    );

  return <ClientCardHHSurveys className={className} />;
};

export default ClientCardHH;
